// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6567":"6b072c61","7568":"6959b58b"}[chunkId] + ".chunk.css";
};